import CSVPreviewSection from '../CSVPreviewSection'

export default function TTDetailCSVPreviewTotalSection(){}

TTDetailCSVPreviewTotalSection.prototype = new CSVPreviewSection();
TTDetailCSVPreviewTotalSection.prototype.constructor = TTDetailCSVPreviewTotalSection;

TTDetailCSVPreviewTotalSection.prototype.init = function( columnStrategy ){
    CSVPreviewSection.prototype.init.call(this);

    this.columnStrategy = columnStrategy;
    return this;
};

TTDetailCSVPreviewTotalSection.prototype.addRows = function(tBody) {
    const row = this.createRow()
    this.columnStrategy.addTotalRowCells(row);
    this.addRow(tBody, row);
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/ttdetail/TTDetailCSVPreviewTotalSection.js